
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c8102e","d":"M0 0h512.1v512H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M144 0h73.1v512H144z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 219.4h512.1v73.2H0z"}})])
          )
        }
      }
    